import { render, staticRenderFns } from "./new.vue?vue&type=template&id=6c0c7386&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c7386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0c7386')) {
      api.createRecord('6c0c7386', component.options)
    } else {
      api.reload('6c0c7386', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=6c0c7386&scoped=true", function () {
      api.rerender('6c0c7386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybzbgl/new.vue"
export default component.exports